/* eslint-disable no-template-curly-in-string */
/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
  flex1FlexItem: Item<'FlexItem'>;
  minMax200200FlexItem: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  canvasGrid: Item<'CanvasGrid'>;
  verticalSearchForm: Item<'SearchForm'>;
  autoFlexItem: Item<'FlexItem'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  searchButton: Item<'Button'>;
  triggerOnClick1: Item<'TriggerOnClick'>;
  toolbarFiller: Item<'ToolbarSpacer'>;
  toolbar: Item<'Toolbar'>;
  clearButton: Item<'Button'>;
  testQuery: Item<'ActionQuery'>;
  testClearFilters: Item<'ActionClearFilters'>;
  pictureImageColumn: Item<'ImageColumn'>;
  idSearchNumberField: Item<'SearchNumberField'>;
  genderSearchTextField: Item<'SearchTextField'>;
  nameTitleSearchSelectField: Item<'SearchSelectField'>;
  nameFirstSearchTextField: Item<'SearchTextField'>;
  nameLastSearchTextField: Item<'SearchTextField'>;
  locationStreetNumberSearchNumberField: Item<'SearchNumberField'>;
  locationStreetNameSearchTextField: Item<'SearchTextField'>;
  locationCitySearchTextField: Item<'SearchTextField'>;
  locationStateSearchTextField: Item<'SearchTextField'>;
  locationCountrySearchTextField: Item<'SearchTextField'>;
  emailSearchTextField: Item<'SearchTextField'>;
  dobDateSearchDateField: Item<'SearchDateField'>;
  dobAgeSearchNumberField: Item<'SearchNumberField'>;
  registeredDateSearchDateField: Item<'SearchDateField'>;
  registeredAgeSearchNumberField: Item<'SearchNumberField'>;
  phoneSearchTextField: Item<'SearchTextField'>;
  cellSearchTextField: Item<'SearchTextField'>;
  idNumberColumn: Item<'NumberColumn'>;
  genderStringColumn: Item<'StringColumn'>;
  nameTitleStringColumn: Item<'StringColumn'>;
  nameFirstStringColumn: Item<'StringColumn'>;
  nameLastStringColumn: Item<'StringColumn'>;
  locationStreetNumberNumberColumn: Item<'NumberColumn'>;
  locationStreetNameStringColumn: Item<'StringColumn'>;
  locationCityStringColumn: Item<'StringColumn'>;
  locationStateStringColumn: Item<'StringColumn'>;
  locationCountryStringColumn: Item<'StringColumn'>;
  emailStringColumn: Item<'StringColumn'>;
  dobDateDateColumn: Item<'DateColumn'>;
  registeredDateDateColumn: Item<'DateColumn'>;
  phoneStringColumn: Item<'StringColumn'>;
  cellStringColumn: Item<'StringColumn'>;
} = {
  autoFlexItem: {
    children: ['toolbar'],
    itemId: 'autoFlexItem',
    parent: 'flexPanel',
    props: {
      sizeType: 'auto',
    },
    type: 'FlexItem',
  },
  canvasGrid: {
    children: [
      'idNumberColumn',
      'nameTitleStringColumn',
      'nameFirstStringColumn',
      'nameLastStringColumn',
      'pictureImageColumn',
      'genderStringColumn',
      'locationStreetNumberNumberColumn',
      'locationStreetNameStringColumn',
      'locationCityStringColumn',
      'locationStateStringColumn',
      'locationCountryStringColumn',
      'emailStringColumn',
      'dobDateDateColumn',
      'registeredDateDateColumn',
      'phoneStringColumn',
      'cellStringColumn',
    ],
    itemId: 'canvasGrid',
    parent: 'flex1FlexItem',
    props: {},
    type: 'CanvasGrid',
  },
  cellSearchTextField: {
    children: [],
    itemId: 'cellSearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Cell' },
      viewAttribute: 'cell',
    },
    type: 'SearchTextField',
  },
  cellStringColumn: {
    children: [],
    itemId: 'cellStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Cell' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'cell',
      width: 156,
    },
    type: 'StringColumn',
  },
  clearButton: {
    children: ['triggerOnClick1'],
    itemId: 'clearButton',
    parent: 'toolbar',
    props: {
      startIcon: {
        iconName: '',
      },
      text: {
        type: 'text',
        value: 'Clear',
      },
      variant: 'text',
    },
    type: 'Button',
  },
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'test',
    },
    type: 'DataStoreReference',
  },
  dobAgeSearchNumberField: {
    children: [],
    itemId: 'dobAgeSearchNumberField',
    parent: 'verticalSearchForm',
    props: {
      dataType: 'Number',
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Age' },
      viewAttribute: 'dob_age',
    },
    type: 'SearchNumberField',
  },
  dobDateDateColumn: {
    children: [],
    itemId: 'dobDateDateColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'DOB' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'dob_date',
      width: 109,
    },
    type: 'DateColumn',
  },
  dobDateSearchDateField: {
    children: [],
    itemId: 'dobDateSearchDateField',
    parent: 'verticalSearchForm',
    props: {
      dataType: 'Date',
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'DOB' },
      viewAttribute: 'dob_date',
      showTime: false,
    },
    type: 'SearchDateField',
  },
  emailSearchTextField: {
    children: [],
    itemId: 'emailSearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Email' },
      viewAttribute: 'email',
    },
    type: 'SearchTextField',
  },
  emailStringColumn: {
    children: [],
    itemId: 'emailStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Email' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'email',
      width: 200,
    },
    type: 'StringColumn',
  },
  flex1FlexItem: {
    children: ['canvasGrid'],
    itemId: 'flex1FlexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['minMax200200FlexItem', 'autoFlexItem', 'flex1FlexItem'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  genderSearchTextField: {
    children: [],
    itemId: 'genderSearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Gender' },
      viewAttribute: 'gender',
    },
    type: 'SearchTextField',
  },
  genderStringColumn: {
    children: [],
    itemId: 'genderStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Gender' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'gender',
      width: 103,
    },
    type: 'StringColumn',
  },
  idNumberColumn: {
    children: [],
    itemId: 'idNumberColumn',
    parent: 'canvasGrid',
    props: {
      allowDecimal: false,
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'ID' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'id',
      width: 73,
    },
    type: 'NumberColumn',
  },
  idSearchNumberField: {
    children: [],
    itemId: 'idSearchNumberField',
    parent: 'verticalSearchForm',
    props: {
      dataType: 'Number',
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'ID' },
      viewAttribute: 'id',
    },
    type: 'SearchNumberField',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      dataFormat: 'ts',
      dataSource: 'test',
      tsData:
        "const resp = await fetch('https://randomuser.me/api/?results=1000');\nconst json = await resp.json();\n\nfunction flattenObject(obj: object, parentKey?: string) {\n    return Object.keys(obj).reduce((o, k) => {\n        let value = obj[k];\n        if (value && typeof value === 'object') {\n            o = { ...o, ...flattenObject(value, parentKey ? `${parentKey}_${k}` : k) };\n        } else {\n            o[parentKey ? `${parentKey}_${k}` : k] = value;\n        }\n        return o;\n    }, {});\n}\n\nreturn json.results.map((r) => flattenObject(r));\n",
    },
    type: 'LocalDataStore',
  },
  locationCitySearchTextField: {
    children: [],
    itemId: 'locationCitySearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'City' },
      viewAttribute: 'location_city',
    },
    type: 'SearchTextField',
  },
  locationCityStringColumn: {
    children: [],
    itemId: 'locationCityStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'City' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'location_city',
      width: 150,
    },
    type: 'StringColumn',
  },
  locationCountrySearchTextField: {
    children: [],
    itemId: 'locationCountrySearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Country' },
      viewAttribute: 'location_country',
    },
    type: 'SearchTextField',
  },
  locationCountryStringColumn: {
    children: [],
    itemId: 'locationCountryStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Country' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'location_country',
      width: 131,
    },
    type: 'StringColumn',
  },
  locationStateSearchTextField: {
    children: [],
    itemId: 'locationStateSearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'State' },
      viewAttribute: 'location_state',
    },
    type: 'SearchTextField',
  },
  locationStateStringColumn: {
    children: [],
    itemId: 'locationStateStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'State' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'location_state',
      width: 146,
    },
    type: 'StringColumn',
  },
  locationStreetNameSearchTextField: {
    children: [],
    itemId: 'locationStreetNameSearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Street Name' },
      viewAttribute: 'location_street_name',
    },
    type: 'SearchTextField',
  },
  locationStreetNameStringColumn: {
    children: [],
    itemId: 'locationStreetNameStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Street Name' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'location_street_name',
      width: 200,
    },
    type: 'StringColumn',
  },
  locationStreetNumberNumberColumn: {
    children: [],
    itemId: 'locationStreetNumberNumberColumn',
    parent: 'canvasGrid',
    props: {
      allowDecimal: false,
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Street Number' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'location_street_number',
      width: 120,
    },
    type: 'NumberColumn',
  },
  locationStreetNumberSearchNumberField: {
    children: [],
    itemId: 'locationStreetNumberSearchNumberField',
    parent: 'verticalSearchForm',
    props: {
      dataType: 'Number',
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Street Number' },
      viewAttribute: 'location_street_number',
    },
    type: 'SearchNumberField',
  },
  minMax200200FlexItem: {
    children: ['verticalSearchForm'],
    itemId: 'minMax200200FlexItem',
    parent: 'flexPanel',
    props: {
      max: 200,
      min: 200,
      overflow: 'scroll',
      sizeType: 'minmax',
    },
    type: 'FlexItem',
  },
  nameFirstSearchTextField: {
    children: [],
    itemId: 'nameFirstSearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'First Name' },
      viewAttribute: 'name_first',
    },
    type: 'SearchTextField',
  },
  nameFirstStringColumn: {
    children: [],
    itemId: 'nameFirstStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'First Name' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'name_first',
      width: 131,
    },
    type: 'StringColumn',
  },
  nameLastSearchTextField: {
    children: [],
    itemId: 'nameLastSearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Last Name' },
      viewAttribute: 'name_last',
    },
    type: 'SearchTextField',
  },
  nameLastStringColumn: {
    children: [],
    itemId: 'nameLastStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Last Name' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'name_last',
      width: 132,
    },
    type: 'StringColumn',
  },
  nameTitleSearchSelectField: {
    children: [],
    itemId: 'nameTitleSearchSelectField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Title' },
      optionValues: {
        type: 'text',
        value: 'Ms,Mrs,Mr,Miss,Mademosiselle,Madame',
      },
      viewAttribute: 'name_title',
    },
    type: 'SearchSelectField',
  },
  nameTitleStringColumn: {
    children: [],
    itemId: 'nameTitleStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Title' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'name_title',
      width: 115,
    },
    type: 'StringColumn',
  },
  phoneSearchTextField: {
    children: [],
    itemId: 'phoneSearchTextField',
    parent: 'verticalSearchForm',
    props: {
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Phone' },
      viewAttribute: 'phone',
    },
    type: 'SearchTextField',
  },
  phoneStringColumn: {
    children: [],
    itemId: 'phoneStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Phone' },
      maxLength: 0,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'phone',
      width: 150,
    },
    type: 'StringColumn',
  },
  pictureImageColumn: {
    children: [],
    itemId: 'pictureImageColumn',
    parent: 'canvasGrid',
    props: {
      alignment: 'center',
      label: { type: 'text', value: 'Picture' },
      rounding: 8,
      viewAttribute: 'picture_thumbnail',
      width: 110,
    },
    type: 'ImageColumn',
  },
  registeredAgeSearchNumberField: {
    children: [],
    itemId: 'registeredAgeSearchNumberField',
    parent: 'verticalSearchForm',
    props: {
      dataType: 'Number',
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Registered Age' },
      viewAttribute: 'registered_age',
    },
    type: 'SearchNumberField',
  },
  registeredDateDateColumn: {
    children: [],
    itemId: 'registeredDateDateColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Registered Date' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'registered_date',
      width: 134,
    },
    type: 'DateColumn',
  },
  registeredDateSearchDateField: {
    children: [],
    itemId: 'registeredDateSearchDateField',
    parent: 'verticalSearchForm',
    props: {
      dataType: 'Date',
      flex: {
        lg: 4,
        sm: 6,
        xl: 3,
        xs: 12,
      },
      label: { type: 'text', value: 'Registered Date' },
      viewAttribute: 'registered_date',
      showTime: false,
    },
    type: 'SearchDateField',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  searchButton: {
    children: ['triggerOnClick'],
    itemId: 'searchButton',
    parent: 'toolbar',
    props: {
      startIcon: {
        iconName: 'search',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Search',
      },
    },
    type: 'Button',
  },
  testClearFilters: {
    children: [],
    itemId: 'testClearFilters',
    parent: 'triggerOnClick1',
    props: {
      alias: 'test',
      clearGridFilters: true,
      clearStoreFilters: true,
    },
    type: 'ActionClearFilters',
  },
  testQuery: {
    children: [],
    itemId: 'testQuery',
    parent: 'triggerOnClick',
    props: {
      alias: 'test',
    },
    type: 'ActionQuery',
  },
  toolbar: {
    children: ['toolbarFiller', 'clearButton', 'searchButton'],
    itemId: 'toolbar',
    parent: 'autoFlexItem',
    props: {},
    type: 'Toolbar',
  },
  toolbarFiller: {
    children: [],
    itemId: 'toolbarFiller',
    parent: 'toolbar',
    props: {},
    type: 'ToolbarSpacer',
  },
  triggerOnClick: {
    children: ['testQuery'],
    itemId: 'triggerOnClick',
    parent: 'searchButton',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick1: {
    children: ['testClearFilters'],
    itemId: 'triggerOnClick1',
    parent: 'clearButton',
    props: {},
    type: 'TriggerOnClick',
  },
  verticalSearchForm: {
    children: [
      'idSearchNumberField',
      'nameTitleSearchSelectField',
      'nameFirstSearchTextField',
      'nameLastSearchTextField',
      'genderSearchTextField',
      'locationStreetNumberSearchNumberField',
      'locationStreetNameSearchTextField',
      'locationCitySearchTextField',
      'locationStateSearchTextField',
      'locationCountrySearchTextField',
      'emailSearchTextField',
      'dobDateSearchDateField',
      'dobAgeSearchNumberField',
      'registeredDateSearchDateField',
      'registeredAgeSearchNumberField',
      'phoneSearchTextField',
      'cellSearchTextField',
    ],
    itemId: 'verticalSearchForm',
    parent: 'minMax200200FlexItem',
    props: {
      formHorizontal: true,
      labelAlignment: 'right',
      labelWidth: 120,
    },
    type: 'SearchForm',
  },
};

const controller = undefined;

export const helpRenders: ComponentSample<'SearchForm'>[] = [
  {
    title: 'Search Form',
    description: 'Sample Search Form',
    page,
    controller,
    exampleId: 'eg-01GT5HQPY09FRJ55BMFYHT11FC',
    clearParentChildren: false,
    height: 480,
    visibleProps: ['formHorizontal', 'labelAlignment', 'labelWidth'],
    item: {
      type: 'SearchForm',
      props: {
        formHorizontal: true,
        labelAlignment: 'right',
        labelWidth: 120,
      },
      itemId: 'verticalSearchForm',
      parent: 'minMax200200FlexItem',
      children: [
        'idSearchNumberField',
        'nameTitleSearchSelectField',
        'nameFirstSearchTextField',
        'nameLastSearchTextField',
        'genderSearchTextField',
        'locationStreetNumberSearchNumberField',
        'locationStreetNameSearchTextField',
        'locationCitySearchTextField',
        'locationStateSearchTextField',
        'locationCountrySearchTextField',
        'emailSearchTextField',
        'dobDateSearchDateField',
        'dobAgeSearchNumberField',
        'registeredDateSearchDateField',
        'registeredAgeSearchNumberField',
        'phoneSearchTextField',
        'cellSearchTextField',
      ],
    },
  },
];
